import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export const EmotionalMirror: React.FC = () => {
  const painPoints = ['El miedo constante a que la comida le haga mal al bebé.', 'La resignación de escuchar que es normal, ya va a pasar.', 'El cansancio extremo de no poder encadenar 3 horas de sueño.'];
  return <section className="py-12 md:py-24 px-4 bg-cream-card" data-id="element-64">
      <div className="max-w-3xl mx-auto" data-id="element-65">
        <h2 className="font-serif text-3xl md:text-4xl text-earth font-bold mb-6 text-center" data-id="element-66">
          Sabemos que a las 2 AM todo se siente más difícil...
        </h2>

        <p className="font-sans text-lg text-earth-light mb-10 text-center leading-relaxed" data-id="element-67">
          Sentís que cada cena es una trampa, que dormir sentada no es descansar
          y que nadie entiende que ese fuego en la garganta te está sacando la
          energía para llegar bien al parto.
        </p>

        <div className="bg-white rounded-2xl p-6 md:p-10 shadow-sm border border-terracotta/10" data-id="element-68">
          <ul className="space-y-6" data-id="element-69">
            {painPoints.map((point, index) => <li key={index} className="flex items-start gap-4" data-id="element-70">
                <CheckCircle2 className="text-sage shrink-0 mt-1" size={24} data-id="element-71" />
                <span className="font-sans text-earth text-lg leading-snug" data-id="element-72">
                  {point}
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
};